// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentSlider_container__2iysD"};